import { render, staticRenderFns } from "./FBlockList.vue?vue&type=template&id=aad5446a&"
import script from "./FBlockList.vue?vue&type=script&lang=js&"
export * from "./FBlockList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports